import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import { fetchKitchenListAsync } from './kitchenListSlice';
import { KitchenFormData } from '../../../app/data/models/kitchens/kitchenFormData';
import { toKitchenFormModel } from '../../../app/data/models/kitchens/kitchenFormModel';

export interface CreateKitchenState {
  status: string;
  dismiss: boolean;
}

const initialState: CreateKitchenState = {
  status: 'idle',
  dismiss: false,
};

export const createKitchenAsync = createAsyncThunk<
  void,
  { restaurantId: string; kitchenDto: KitchenFormData }
>('kitchens/create', async ({ restaurantId, kitchenDto }, thunkApi) => {
  try {
    await api.Kitchen.create(restaurantId, toKitchenFormModel(kitchenDto));
    thunkApi.dispatch(fetchKitchenListAsync(restaurantId));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return thunkApi.rejectWithValue({ error: error.data });
  }
});

export const createKitchenSlice = createSlice({
  name: 'createKitchen',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createKitchenAsync.pending, (state) => {
      state.status = 'pendingCreateKitchen';
    });
    builder.addCase(createKitchenAsync.fulfilled, (state) => {
      state.status = 'idle';
      state.dismiss = true;
    });
    builder.addCase(createKitchenAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
